import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AccountTemplatesAPI from '../../api/superAdmin/accountTemplates';
import SuperAdminFeatureFlagsAPI from '../../api/superAdmin/featureFlags';

export const state = {
  records: [],
  featureFlags: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
    fetchingFeatureFlags: false,
  },
};

export const getters = {
  getAccountTemplates($state) {
    return $state.records;
  },
  getFeatureFlagsList($state) {
    return $state.featureFlags;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  fetchAccountTemplates: async function fetchAccountTemplates({ commit }) {
    commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, { fetchingList: true });
    try {
      const { data } = await AccountTemplatesAPI.get();
      commit(types.default.SET_ACCOUNT_TEMPLATES, data);
    } finally {
      commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  createAccountTemplate: async function createAccountTemplate(
    { commit },
    accountTemplateObj
  ) {
    commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, { creatingItem: true });
    try {
      const { data } = await AccountTemplatesAPI.create({
        account_template: accountTemplateObj,
      });
      commit(types.default.ADD_ACCOUNT_TEMPLATE, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  updateAccountTemplate: async function updateAccountTemplate(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, { updatingItem: true });
    try {
      const { data } = await AccountTemplatesAPI.update(id, {
        account_template: updateObj,
      });
      commit(types.default.EDIT_ACCOUNT_TEMPLATE, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  deleteAccountTemplate: async function deleteAccountTemplate({ commit }, id) {
    commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, { deletingItem: true });
    try {
      await AccountTemplatesAPI.delete(id);
      commit(types.default.DELETE_ACCOUNT_TEMPLATE, id);
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, {
        deletingItem: false,
      });
    }
    return id;
  },

  fetchFeatureFlagsList: async function fetchFeatureFlagsList({ commit }) {
    commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, {
      fetchingFeatureFlags: true,
    });
    try {
      const { data } = await SuperAdminFeatureFlagsAPI.get();
      commit(types.default.SET_FEATURE_FLAGS_LIST, data);
    } finally {
      commit(types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG, {
        fetchingFeatureFlags: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_ACCOUNT_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  [types.default.SET_ACCOUNT_TEMPLATES]: MutationHelpers.set,
  [types.default.ADD_ACCOUNT_TEMPLATE]: MutationHelpers.create,
  [types.default.EDIT_ACCOUNT_TEMPLATE]: MutationHelpers.update,
  [types.default.DELETE_ACCOUNT_TEMPLATE]: MutationHelpers.destroy,

  [types.default.SET_FEATURE_FLAGS_LIST](_state, data) {
    _state.featureFlags = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
